import {useCallback} from 'react';
import {useSubmitMissionProgress} from './useSubmitMissionProgress';

export const useSubmitAddToWishlistMission = () => {
  const submitLikeProductMission = useSubmitMissionProgress({
    mission: 'addToWishlistMission',
  });

  const onAddToWishlistSuccess = useCallback(
    (productId: number) => {
      submitLikeProductMission(productId);
    },
    [submitLikeProductMission],
  );

  return onAddToWishlistSuccess;
};
